import { EpicRefined } from 'interfaces/middleware'
import { AdvisorLandingPageActions, GetTopAdvisorsAction, GetTopAdvisorsReviewsAction } from 'components/features/coaching/advisorStore/actions/advisorLandingPageActions'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMap, map } from 'rxjs/operators'
import { GET_TOP_ADVISORS_URL, GET_ADVISOR_TOP_REVIEWS_URL } from 'interfaces/ajax'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { of } from 'rxjs'


export const getTopAdvisorsEpic: EpicRefined<AdvisorLandingPageActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetTopAdvisorsAction.type),
  mergeMap((action) => get(GET_TOP_ADVISORS_URL).pipe(
    map(({ response }) => action.success(response.items)),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
  ))
)

export const getTopAdvisorsReviewsEpic: EpicRefined<AdvisorLandingPageActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetTopAdvisorsReviewsAction.type),
  mergeMap((action) => get(GET_ADVISOR_TOP_REVIEWS_URL).pipe(
    map(({ response }) => action.success(response.items)),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
  ))
)
